// Dates in the files list, always as Vilnius calendar days (same as PrettyDate).
// The row shows days only; the exact time goes into a tooltip.
import { formatPrettyDate } from "utils/helperFunctions";
import { vilniusTodayYmd } from "utils/vilnius-date";

type DateValue = string | number | null | undefined;

/** "2026-03-05", or "" when there is no usable date. */
export function formatDay(value: DateValue): string {
  const day = formatPrettyDate(value, "lt-LT", false);
  return day === "-" ? "" : day;
}

/** "2026-03-05 14:06:01" for a tooltip, or "" when there is no usable date. */
export function formatDateTime(value: DateValue): string {
  const dateTime = formatPrettyDate(value, "lt-LT", true);
  return dateTime === "-" ? "" : dateTime;
}

/** Signer chips: "03-05" within the current year, "2025-03-05" otherwise. */
export function formatShortDay(value: DateValue, todayYmd = vilniusTodayYmd()): string {
  const day = formatDay(value);
  if (!day) return "";
  return day.slice(0, 4) === todayYmd.slice(0, 4) ? day.slice(5) : day;
}
